import React from 'react';
import { startCase } from 'lodash';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { FONT_GSS_FUTURA } from '@monorepo/shared/src/themes/defaultTheme';
import { useSoundOutWords } from 'state/hooks/use-sound-out-words';

const SpelledWord: React.FC = () => {
  const classes = useStyles();
  const [{ selectedWord, spelledCharacter }] = useSoundOutWords();

  const shouldCapitalize = (index: number) => index === 0 && selectedWord.capitalize;

  const renderSoundDescription = (step: string, index: number) =>
    shouldCapitalize(index) ? startCase(step) : step;

  return (
    <div className={classes.container}>
      {selectedWord.text.map((step, index) => (
        <span
          key={index}
          className={`${
            spelledCharacter.character === step && spelledCharacter.index === index
              ? classes.spelledCharacter
              : ''
          } `}
        >
          {renderSoundDescription(step, index)}
        </span>
      ))}
    </div>
  );
};

export default SpelledWord;

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    fontWeight: 600,
    fontFamily: FONT_GSS_FUTURA,
    fontSize: theme.typography.pxToRem(140),
    lineHeight: theme.typography.pxToRem(140),
    letterSpacing: theme.typography.pxToRem(5),
  },
  spelledCharacter: {
    color: theme.palette.secondary.dark,
    fontSize: '180px',
  },
}));
